import { Component, OnInit } from '@angular/core';
import { HttpErrorResponse, HttpHeaders, HttpClient } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { Router, ActivatedRoute } from '@angular/router';
import { User } from '../../_models/user';
import { ApiIntegration } from '../../_services/api.integration';
import { Globals } from '../../_models/globals';
import { AlertService } from '../../_services/alert.service';
//import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';

@Component({
  selector: 'app-api-settings',
  templateUrl: './api-settings.component.html',
  styleUrls: ['./api-settings.component.scss'],
})
export class ApiSettingsComponent implements OnInit {

  accessKey: any;
  //secretKey : string;
  accessKeyErrorMessage: string;
  apiDelete: any;
  openList: any;
  notificationId: any;
  url: string;
  urlError: string;
  getApiKey: string;
  getSecretKey: string;
  getApiKeyError: string;
  getSecretKeyError: string;
  errorMessage: string;
  createApiPopUp: string = 'N';
  deletePopUp: string = 'N';
  viewPopup: string = 'N';
  arrayDate: any = [];
  viewData: any = {};
  constructor(private alertService: AlertService, private http: HttpClient, private g: Globals, private api: ApiIntegration, public user: User, private route: ActivatedRoute, private router: Router) {
    //this.secretKey='';
    this.getAccess();
    // this.getOpenList();

  }

  closePopUp() {
    this.createApiPopUp = 'N';
    this.url = "";
  }

  /* To copy Text from Textbox */
  copyInputMessage(inputElement) {
    inputElement.select();
    document.execCommand('copy');
    inputElement.setSelectionRange(0, 0);
  }

  getAccess() {
    this.api.getAccessKey(this.user.accountOwnerId).subscribe((data: any) => {
      this.accessKey = data.apiKeys;
      //this.arrayDate.push(this.accessKey);
      //this.getApiKey = data.apiKey;
      //this.getSecretKey = data.secretKey;
      //this.url = data.redirectUrl;
    },
      err => { console.log(err); });
  }

  getOpenList() {
    this.api.getApiSettingsList("", this.user.accountOwnerId, "1").subscribe((data: any) => {
      this.openList = data.openApiSettingsResponses;
      this.openList.forEach((notification) => {
        notification.apiSettingsResponses.forEach((n) => {
          if (n.notify === 'ON') {
            n.enabled = true;
          } else {
            n.enabled = false;
          }
        });
      });

    }, err => {
      console.log(err);
    });
  }

  sliceUPto(num) {
    if (num) {
      if (num % 2 == 0) {
        return num / 2;
      } else {
        return (num + 1) / 2;
      }
    } else {
      return 0;
    }
  }

  createApi() {
    this.createApiPopUp = 'Y';
  }

  closeViewPopUp() {
    this.viewPopup = 'N';
  }

  viewDetails(data) {
    this.viewPopup = 'Y';
    this.viewData = data;
  }

  closeDeletePopup() {
    this.deletePopUp = 'N';
  }

  ngOnInit() {
    //this.secretKey='';
  }

  keyGenerate() {
    this.g.loaderDisplay = "display";
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));

    this.http.post(environment.apiUrl + 'api/generateAPIKey?accountOwnerId=' + this.user.accountOwnerId, {
      //"accountOwnerId": this.user.accountOwnerId
    },
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.getApiKey = data['apiKey'];
          this.getSecretKey = data['secretKey'];
          this.alertService.success('Secrete Key', 'Generated Successfully');
          //this.secretKey = data['secretKey']
          //this.getAccess();
        }
        else {
          this.accessKeyErrorMessage = data['message'];
          this.alertService.error('Error', data['message']);
        }
        this.g.loaderDisplay = "";

      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });
  }

  save() {

    this.getApiKeyError = "";
    this.getSecretKeyError = "";
    this.urlError = "";

    if (!this.getApiKey) {
      this.getApiKeyError = "Generate the Apikey And SecreteKey";
    }

    if (!this.getSecretKey) {
      this.getSecretKeyError = "Generate the Apikey And SecreteKey";
    }

    if (!this.url) {
      this.urlError = "Please Enter The URL";
    }

    if (this.getApiKeyError != "" || this.getSecretKeyError != "" || this.urlError != "") {
      return false;
    }

    this.g.loaderDisplay = "display";
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));

    this.http.post(environment.apiUrl + 'api/saveAPIKey', {
      "accountOwnerId": this.user.accountOwnerId,
      "apiKey": this.getApiKey,
      "organizationId": this.user.organizationId,
      "redirectUrl": this.url,
      "secretKey": this.getSecretKey
    },
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('Created Successfully', '');
          //this.getAccess();
          this.closePopUp();
          this.getApiKey = "";
          this.getSecretKey = "";
          this.url = "";
        }
        else {
          this.accessKeyErrorMessage = data['message'];
          this.alertService.error('Error', data['message']);
        }
        this.g.loaderDisplay = "";

      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });
  }


  deleteApis() {
    this.g.loaderDisplay = "display";
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.delete(environment.apiUrl + 'api/deleteAccessKey/' + this.apiDelete.id,
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        this.alertService.success('Delete AccessKey', 'Deleted Successfully');
        this.closeDeletePopup();
        this.getAccess();
        //this.accessKey.apiKey='';
        //this.accessKey.secretKey='';
        //this.router.navigate(['/admin/myAccountList']);
        if (data['code'] == 200) {
          this.closeDeletePopup();
        }
        else { }
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
          console.log(err);

        }
      );
  }

  deleteApi(r) {
    this.deletePopUp = 'Y';
    this.apiDelete = r;
  }

  openUpdateStatus(n, id) {
    // alert("value ::" + n.displayPriority);
    //if (n.enabled == true) {
    //this.notificationId = n.settingsId;
    //} else {
    //this.notificationId = n.id;
    //}
    this.g.loaderDisplay = "display";
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/createApiSettings', {
      "accountOwnerId": this.user.accountOwnerId,
      "openApiTypeId": n.openApiTypeId,
      "id": n.settingsId,
      "notify": n.enabled ? "OFF" : "ON",
      "organizationId": 1
    },
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == "200") {
          this.alertService.success('Api', 'Status Updated Successfully');
          this.getOpenList();
        } else {
          this.alertService.error(data['message']);
        }
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });
  }

}
